import { jwtDecode } from 'jwt-decode'

export const decodeRoles = (
  token: string,
  clientId: string
): string[] | null => {
  try {
    const decoded: any = jwtDecode(token)
    console.log('decoded', decoded)

    const resourceAccess = decoded?.resource_access

    if (!resourceAccess || !resourceAccess[clientId]) {
      console.warn(`ClientId "${clientId}" not found in resource_access`)
      return null
    }

    return resourceAccess[clientId].roles || []
  } catch (error) {
    console.error('Error decoding token:', error)
    return null
  }
}
